import { ApiError } from '@/api/client';

/** Best-effort human message from any thrown value. */
export function errorMessageOf(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (error instanceof ApiError && error.message) {
    return error.message;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

/** True when the error indicates an invalid/expired session (re-connect needed). */
export function isAuthError(error: unknown): boolean {
  return error instanceof ApiError && error.isAuthError;
}
